export const checkMin = (value: number, min: number) => (value < min ? `Minimum is ${min}` : '')

export const checkMinAsync = (value: number, min: number) => Promise.resolve(checkMin(value, min))
